import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useGateValue } from '@statsig/react-bindings';
import { useLocale, useTranslations } from 'next-intl';

import SectionHeading from '@/app/components/SectionHeading';

const HowItWorksHero = () => {
  const t = useTranslations();
  const locale = useLocale();
  const enabled = useGateValue('how_it_works_hero_copy_update');

  return (
    <section
      className="relative z-10 bg-sandstone-200"
      data-cy="how-it-works-hero"
    >
      <LayoutGrid className="pt-36 pb-16 md:pt-40">
        <GridItem
          colEnd={{ sm: 'main', lg: 12, xl: 10 }}
          colStart={{ sm: 'main', lg: 'main', xl: 'main' }}
        >
          <Typography
            className="mb-6 uppercase"
            Element="h1"
            variant="body-large"
            weight="bold"
          >
            {t('how_it_works_hero_eyebrow')}
          </Typography>
          <SectionHeading
            animated
            content="how_it_works_hero_title"
            emAnimationProps={{
              transition: { duration: 2, type: 'tween', delay: 0.25 },
            }}
            indentation="pl-16 md:pl-24 lg:pl-32 xl:text-right"
            multiline
            typographyProps={{
              className: 'md:justify-start leading-heading tracking-tighter',
              color: 'dark',
              Element: 'h2',
              variant: 'h1',
            }}
            wrapperAnimationProps={{
              transition: { duration: 1, type: 'tween' },
              viewport: { once: true },
            }}
          />
        </GridItem>
        <GridItem
          className="flex flex-col justify-center pt-4 lg:py-32"
          colEnd={{ sm: 'main', lg: 23 }}
          colStart={{ sm: 'main', lg: 15 }}
        >
          <Typography variant="body-large">
            {t(
              enabled && locale === 'en'
                ? 'how_it_works_hero_copy_update_September_2025'
                : 'how_it_works_hero_copy',
            )}
          </Typography>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default HowItWorksHero;
